"use client";
import { useEffect, useState } from "react";
import { getNoise } from "@/utils/noise";
import classNames from "classnames";
import { SocialProofAvatars } from "@/components/molecules/SocialProofAvatars";
import { MIN_SOCIAL_PROOF, MAX_SOCIAL_PROOF } from "@/constants/noise";
import { trackSocialProofPopupShown } from "@/utils/mixpanel";

export const SocialProofTooltip = ({ isMobile }) => {
	const [isActive, setIsActive] = useState(false);
	const noise = getNoise("glutenfreeq", {
		min: MIN_SOCIAL_PROOF,
		max: MAX_SOCIAL_PROOF,
		range: MAX_SOCIAL_PROOF - MIN_SOCIAL_PROOF,
	});

	useEffect(() => {
		if (!isMobile) {
			trackSocialProofPopupShown({ delay: 0 });
		}

		setTimeout(() => {
			setIsActive(true);
			trackSocialProofPopupShown({ delay: 15 });
		}, 15 * 1000);
	}, [isMobile]);

	if (!isMobile) return null;

	return (
		<div
			onClick={() => setIsActive(false)}
			className={classNames({
				"text-white": true,
				"bg-[#212b37]": true,
				"h-8 px-2 py-1 w-fit font-inter text-[13px]": true,
				"rounded-lg justify-center items-center gap-1 flex flex-nowrap": true,
				"absolute -top-1 inset-x-0 m-auto transform -translate-y-1/2": true,
				"transition-opacity duration-300": true,
				"opacity-100 pointer-events-auto": isActive,
				"opacity-0 pointer-events-none": !isActive,
			})}>
			<SocialProofAvatars
				count={5}
				avatarsBorderColor="#212b37"
			/>
			<div>{noise.value} joined today</div>
			<div className="absolute inset-x-0 skew-y-[11deg] scale-50 -bottom-[5.3px] -z-10 m-auto size-3 rounded-[2px] rotate-[40deg] bg-[#212b37]" />
		</div>
	);
};
